<template>
    <div>
        <card-header title='User Notes' subheader="Scott Lamont" icon="fa-clipboard"/>

        <card-toolbar>
            <button><i class="far fa-comment-alt-plus"></i>New Note</button>
        </card-toolbar>

        <card-body toolbar subheader>

            <!-- Text Area -->
            <b-row>
                <b-col class="mt-4">
                    <b-form-textarea v-if="newTextArea === true" v-model="text" placeholder="Type note here ..." rows="3" max-rows="6" size="sm"></b-form-textarea>
                </b-col>
            </b-row>
            <!-- Message / Badges -->
            <b-row class="pl-3 pr-3">
                <b-col class="mt-4">
                    <h6>1/1/20</h6>
                    <p class="font-italic smaller">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="separator mt-4 mb-3"></div>
                </b-col>
            </b-row>
            <!-- New Note -->
            <!-- Message / Badges -->
            <b-row class="pl-3 pr-3">
                <b-col class="mt-4">
                    <h6>{{todaysDate}}</h6>
                    <p class="font-italic smaller">{{ text }}</p>
                </b-col>
            </b-row>
        </card-body>

        <card-footer>
            4
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    // import { BIcon, BIconFileEarmarkPlus } from 'bootstrap-vue'
    import CardFooter from "../../components/common/CardFooter";
    import CardBody from "../../components/common/CardBody";
    import CardToolbar from "../../components/common/CardToolbar";

    export default {
        components: {
            CardToolbar,
            CardBody,
            CardFooter,
            CardHeader, BIcon, BIconFileEarmarkPlus
        },

        methods: {
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            },

            showTextArea: function (){
                return this.newTextArea = !this.newTextArea
            },

            todaysDateFunction: function(){
                return new Date().toLocaleString();
            }
        },

        data(){
            return {
                newTextArea: false,
                text: ''
            }
        }
    }
</script>

<style>
    .smaller {
        font-size: 12px;
    }
    .btn-primary {
        background-color: #336699;
        border-color: #336699;
    }
    .xs-text {
        font-size: 10px
    }
    .gray-border {
        border: 1px solid #f1f1f1;
        padding: 5px;
    }
    .separator {
        border-bottom: 1px solid #cccccc
    }
</style>
